import { Button } from "../components/ui/button";
import { Download } from "lucide-react";

const toCSV = (rows, columns) => {
  const header = columns.map((c) => `"${c.label.replace(/"/g, '""')}"`).join(",");
  const body = rows
    .map((r) =>
      columns
        .map((c) => {
          const v = typeof c.accessor === "function" ? c.accessor(r) : r[c.accessor];
          const s = v === null || v === undefined ? "" : String(v);
          return `"${s.replace(/"/g, '""')}"`;
        })
        .join(",")
    )
    .join("\n");
  return `${header}\n${body}`;
};

export const DataTable = ({ rows = [], columns = [], filename = "data.csv", testId }) => {
  const download = () => {
    const csv = toCSV(rows, columns);
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="w-full" data-testid={testId}>
      <div className="flex justify-end mb-2">
        <Button
          variant="outline"
          size="sm"
          onClick={download}
          data-testid={`${testId}-export-csv`}
          className="h-8 text-xs"
        >
          <Download className="w-3.5 h-3.5 mr-1.5" />
          Exportar CSV
        </Button>
      </div>
      <div className="overflow-x-auto rounded border border-slate-200">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600">
            <tr>
              {columns.map((c) => (
                <th
                  key={c.key}
                  className="text-left px-3 py-2 text-[11px] tracking-[0.05em] uppercase font-semibold border-b border-slate-200"
                >
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr>
                <td
                  colSpan={columns.length}
                  className="text-center text-slate-400 py-8 text-sm"
                >
                  Sin datos para el rango seleccionado
                </td>
              </tr>
            )}
            {rows.map((r, i) => (
              <tr
                key={i}
                className={i % 2 ? "bg-slate-50/50" : "bg-white"}
                data-testid={`${testId}-row-${i}`}
              >
                {columns.map((c) => (
                  <td
                    key={c.key}
                    className="px-3 py-2 border-b border-slate-100 text-slate-700 whitespace-nowrap"
                  >
                    {typeof c.render === "function"
                      ? c.render(r)
                      : typeof c.accessor === "function"
                      ? c.accessor(r)
                      : r[c.accessor]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
